import {
  LitElement,
  html
} from 'lit';
import { styleMap } from 'lit/directives/style-map.js';
import LoadingSpinnerStyle from './style.js';

export class LdsLoadingSpinner extends LitElement {
  static get styles() {
    return LoadingSpinnerStyle;
  }

  static properties = {
    decorative: { type: Boolean },
    ariaLabel: { type: String },
    size: { type: Number },
    animationSpeed: { type: Number },
  };

  constructor() {
    super();
    this.decorative = false;
    this.ariaLabel = 'loading';
    this.size = 40;
    this.animationSpeed = 1000;
  }

  render() {
    const loadingSpinnerSize = {
      height: `${this.size}px`,
      width: `${this.size}px`,
    };
    const loadingSpinnerSpeed = {
      animationDuration: `${this.animationSpeed}ms`,
      '-webkit-animation-duration': `${this.animationSpeed}ms`,
      '-moz-animation-duration': `${this.animationSpeed}ms`,
      '-o-animation-duration': `${this.animationSpeed}ms`,
    };

    return html`
      <div
        style="${styleMap(loadingSpinnerSize)}"
        aria-label="${this.ariaLabel}"
        aria-hidden="${this.decorative}"
        class="lds-loading-spinner"
        role="alert"
        aria-live="assertive"
      >
        <svg
          style="${styleMap({ ...loadingSpinnerSize, ...loadingSpinnerSpeed })}"
          viewBox="0 0 40 40"
          xmlns="http://www.w3.org/2000/svg"
          class="lds-loading-spinner-svg"
        >
          <title>Loading icon</title>
          <defs>
            <linearGradient
              id="loading-spinner-gradient-id"
              x1="0%"
              y1="0%"
              x2="0%"
              y2="100%"
            >
              <stop
                class="grad-stop-1"
                offset="10%"
              />
              <stop
                class="grad-stop-2"
                offset="90%"
              />
            </linearGradient>
          </defs>
          <path
            class="lds-loading-spinner-svg-circle"
            d="M20,40V36A16,16,0,1,1,36,20,16,16,0,0,1,20,36v4A20,20,0,1,0,0,20,20,20,0,0,0,20,40Z"
          />
          <circle
            class="lds-loading-spinner-svg-cap"
            cx="20.1"
            cy="38"
            r="2"
          />
          <path
            style="fill: url(#loading-spinner-gradient-id)"
            class="lds-loading-spinner-svg-tail"
            d="M20,0V4a16,16,0,0,1,0,32v4A20,20,0,0,0,20,0Z"
          />
        </svg>
      </div>
    `;
  }
}

export function defineComponent() {
  if (!window.customElements.get('lds-loading-spinner')) window.customElements.define('lds-loading-spinner', LdsLoadingSpinner);
}

export default { LdsLoadingSpinner, defineComponent };
